export default __webpack_public_path__ + "static/media/main_img.c812e130.png";